import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';
import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import './quote.css';
import SEO from '../seo';

export default function GetQuote() {

    const [phone, setPhone] = useState("");

    const formRef = useRef();

    const handleSubmit = (e) => {
        e.preventDefault();

        // Captcha validation added here
        if (!checked) {
            toast.error("Please verify the captcha!");
            return;
        }

        const form = e.target;

        const templateParams = {
            fullname: form[0].value,
            company: form[1].value,
            phone: phone,
            email:form[3].value,
            subject: form[4].value,
            message: form[5].value,
        };

        emailjs
            .send(
                "service_2ligndb",
                "template_uh87x63",
                templateParams,
                "YrP5ujLgYzaXkR75I"
            )
            .then(() => {
                toast.success("Your message sent successfully!");
                // --- Reset form fields ---
                form.reset();
                setPhone("");          // reset phone
                setChecked(false); // reset captcha
            })
            .catch(() => {
                toast.error("Something went wrong! Please try again.");
            });

    };

    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);

    const handleClick = () => {
        if (!checked && !loading) {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setChecked(true);
            }, 1500); // loader duration
        }
    };

    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];

    return (
        <div>
            <SEO
                title="Get a Quote"
                description="Phone Number Whatsapp Number &#8212;Please choose an option&#8212;₹ 0 &#8211; ₹ 4,999₹ 5,000 &#8211; ₹ 9,999₹ 10000 &#8211; ₹ 24999₹ 25,000 &#8211; ₹ 49,999₹ 50,000 &#8211; ₹ 99,999₹ 1,00,000 &#8211; ₹ 4,99,999₹ 5,00,000 &#8211; ₹ 10,00,000"
                canonical="https://www.hwplindia.com/get-a-quote/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <ToastContainer position="top-center" autoClose={3000} style={{ marginTop: "80px" }} />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Get a Quote</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Get a Quote</li>
                    </ul>
                </div>
            </section>

            <section className="contact-section">
                <div className="contact-container">

                    {/* Right Side */}
                    <div className="contact-right quote-right">
                        <form className="form quote-form" ref={formRef} onSubmit={handleSubmit}>
                            <div className="form-row">
                                <input type="text" placeholder="Your Full Name*" required />
                                <input type="text" placeholder="Company Name*" required />
                               
                            </div>

                            <div className="form-row1 quote-row">

                                {/* Phone Number */}
                                <div className="quote-group">
                                    <PhoneInput
                                        country={'in'}
                                        value={phone}
                                        onChange={setPhone}
                                        inputClass="phone-input"
                                        buttonClass="phone-flag"
                                        enableSearch={true}
                                    />
                                </div>

                                {/* WhatsApp Number */}
                                <div className="quote-group">
                                     <input type="email" placeholder="Your Email*" required />
                                </div>

                            </div>

                            <select name="subject" class="quote-select" required>
                                <option value="" hidden>--Service Required--</option>
                                <option value="Website Development">Website Development</option>
                                <option value="ERP Development">ERP Development</option>
                                <option value="Custom Software">Custom Software</option>
                                <option value="Odoo Development">Odoo Development</option>
                                <option value="Mobile Application">Mobile Application</option>
                                <option value="Cloud Server">Cloud Server</option>
                                <option value="Other Requirement">Other Requirement</option>
                            </select>

                            <textarea
                                placeholder="Remarks*"
                                rows="3"
                            ></textarea>

                            <div className="recaptcha-box" onClick={handleClick}>
                                <div className="recaptcha-left">
                                    <div
                                        className={`checkmark-box ${loading ? "loading" : checked ? "checked" : ""
                                            }`}
                                    >
                                        {!loading && !checked && <div className="empty-box"></div>}
                                        {loading && <div className="spinner"></div>}
                                        {checked && <div className="tick">✓</div>}
                                    </div>
                                    <span className="captcha-text">I'm not a robot</span>
                                </div>

                                <div className="recaptcha-right">
                                    <img
                                        src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
                                        alt="reCAPTCHA"
                                        className="captcha-logo"
                                    />
                                    <p>
                                        reCAPTCHA<br />
                                        <span>Privacy - Terms</span>
                                    </p>
                                </div>
                            </div>

                            <button type="submit" className="send-btn">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}